export default "__VITE_ASSET__C4_ah87l__"